import {h, Fragment} from "preact"
import { useAppState, Keywords, AutocompleteElement, useCurrencyFormatting } from '@nosto/preact'
import DropdownProduct from "./DropdownProduct"
import { closeSearch } from '../helpers'

export default function Autocomplete() {
    const { format } = useCurrencyFormatting();
    const { response: { products, keywords, query } } = useAppState();
    const foundResults = products && products.total > 0;

    const handleKeywordClick = (e) => {
        if(e.target.closest('.ns-autocomplete-element')) {
            closeSearch();
        }
    }

    return (
        <div class="ns-autocomplete" data-nosto-element="autocomplete">
            {foundResults && (
                <div class="ns-autocomplete-content" role="listbox">
                    {/* keywords */}
                    {keywords?.hits?.length > 0 && (
                        <div>
                            <h2 id="ns-keywords-suggestions" class="ns-autocomplete-heading text-body">
                                Sugerencias
                            </h2>
                            <ul 
                                class="ns-keywords-list list-unstyled" 
                                role="group" 
                                aria-labelledby="ns-keywords-suggestions"
                                onClick={handleKeywordClick}
                            >
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </ul>
                        </div>
                    )}
                    {/* products */}
                    {products?.hits?.length > 0 && (
                        <>
                        <div class="ns-autocomplete-products">
                            <h2  id="ns-products-suggestions" class="ns-autocomplete-heading text-body">Productos</h2>
                            <ul class="ns-products-list list-unstyled" role="group" aria-labelledby="ns-products-suggestions">
                                <li 
                                    class="ns-autocomplete-list-item"
                                    aria-selected="false"
                                    role="option"
                                >
                                    <a href="/pages/beneficios" tabindex="-1">
                                        {/* desktop */}
                                        <div class="ns-promo-banner_desktop">
                                            <div class="media ratio" style="--ratio-percent: 33.33333333333333%;">
                                                <img 
                                                    src="//cdn.shopify.com/s/files/1/0604/8373/1606/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5.jpg?v=1712341454&amp;width=450" alt="" srcset="//cdn.shopify.com/s/files/1/0604/8373/1606/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5.jpg?v=1712341454&amp;width=352 352w, //cdn.shopify.com/s/files/1/0604/8373/1606/files/DESKTOP_8cd7cad9-10a8-4cbe-9fce-eac14647a7e5.jpg?v=1712341454&amp;width=450 450w" 
                                                    width="450" 
                                                    loading="lazy"
                                                    alt="Banner de promoción de beneficios"
                                                />
                                            </div>
                                        </div>
                                        {/* mobile */}
                                        <div class="ns-promo-banner_mobile">
                                            <div class="media ratio" style="--ratio-percent: 83.33333333333334%;">
                                                <img 
                                                    src="//cdn.shopify.com/s/files/1/0604/8373/1606/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded.jpg?v=1712341454&amp;width=450" alt="" srcset="//cdn.shopify.com/s/files/1/0604/8373/1606/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded.jpg?v=1712341454&amp;width=352 352w, //cdn.shopify.com/s/files/1/0604/8373/1606/files/MOBILE_47cf2b40-7dde-4c87-9627-e93f14c1dded.jpg?v=1712341454&amp;width=450 450w"
                                                    width="450" 
                                                    loading="lazy"
                                                    alt="Banner de promoción de beneficios"
                                                />
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                {products.hits.map((hit) => {
                                    const { productId, imageUrl, name, price, url } = hit;
                                    return (
                                        <li
                                            key={productId}
                                            class="ns-autocomplete-list-item"
                                            data-nosto-element="product"
                                            aria-selected="false"
                                            role="option"
                                        >
                                            <AutocompleteElement
                                                hit={hit}
                                                class="ns-autocomplete-product"
                                                tabindex="-1"
                                            >
                                                <img 
                                                    class="ns-autocomplete-product-image"
                                                    srcset={`${imageUrl.replace('.jpg', '_90x.jpg').replace('.png', '_90x.png').replace('.webp', '_90x.webp')}`}
                                                    src={`${imageUrl.replace('.jpg', '_150x.jpg').replace('.png', '_150x.png').replace('.webp', '_150x.webp')}`}
                                                    sizes="(max-width): 90px,100vw"
                                                    width="60"
                                                    height="60"
                                                    alt={name}
                                                    loading="lazy"
                                                />

                                                <div class="ns-autocomplete-product-content">
                                                    <span class="ns-autocomplete-product-name">{name}</span>
                                                    <span class="ns-autocomplete-product-price">{format(price)}</span>
                                                </div>
                                            </AutocompleteElement>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        <div>
                            <button 
                                type="submit" 
                                class="ns-autocomplete-submit link link--text" 
                                aria-selected="false" 
                                role="option"
                                tabindex="-1"
                                onClick={closeSearch}
                            >
                                Buscar "{query}"
                            </button>
                        </div>
                        </>
                    )}
                </div>
            )}
            <span class="hidden">
                {!foundResults
                    ?   `No se encontraron resultados para “${query}” Revisa la ortografía o usa una palabra o frase diferente.`
                    :   `Resultados para ${query}: ${products?.total} productos`
                }
            </span>
            <span class="visually-hidden" role="status" aria-hidden={foundResults}>
                {!foundResults
                    ?   `No se encontraron resultados para “${query}” Revisa la ortografía o usa una palabra o frase diferente.`
                    :   `Resultados para ${query}: ${products?.total} productos`
                }
            </span>
        </div >
    )
}

function Keyword({ hit }) {
    return (
        <span class="ns-keyword-text" data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <li class="ns-autocomplete-list-item" aria-selected="false" role="option">
            <AutocompleteElement hit={hit} filter={filter} class="ns-keyword-item" tabindex="-1">
                {keywordComponent}
            </AutocompleteElement>
        </li>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span>
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}